import axios from '@/utils/request'

export default {
	//  2023-04-24
	updateTotal(id, params) {
		return axios.put('/weddingDressHall/deposit/' + id + '/update-total', params)
	},

}
